export default __webpack_public_path__ + "static/sosa_logo-0ddb69fb5517dcfa3c65cacf8077824d.png";